(() => {
  'use strict';

  const configNode = document.querySelector('[data-site-controls-config]');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch (_) {}
  const basketEnabled = config.basketEnabled === true;
  window.DreamItSiteControls = Object.freeze({ basketEnabled });
  if (basketEnabled) return;

  const isPurchaseRequest = (input) => {
    const rawUrl = typeof input === 'string' ? input : input instanceof URL ? input.href : input?.url;
    if (!rawUrl) return false;
    try {
      const url = new URL(rawUrl, window.location.origin);
      const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:cart|checkouts?)(?:\/|$))/i, '');
      return url.origin === window.location.origin
        && (/^\/cart\/add(?:\.js)?\/?$/.test(path) || /^\/checkouts?(?:\/|$)/.test(path) || /^\/cart\/\d+:\d+(?:,\d+:\d+)*\/?$/.test(path));
    } catch (_) { return false; }
  };
  const blockedError = () => new DOMException('Basket and checkout entry are disabled.', 'NotAllowedError');
  const purchaseSelector = '[name="add"], [name="checkout"], [data-shopify="payment-button"], .shopify-payment-button';
  const lockPurchasing = () => {
    document.querySelectorAll(`${purchaseSelector}, a[href]`).forEach((control) => {
      if (control.matches('a') && !isPurchaseRequest(control.getAttribute('href'))) return;
      if ('disabled' in control && !control.disabled) control.disabled = true;
      if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
      if (control.matches('a')) control.removeAttribute('href');
    });
  };
  const blockPurchase = (event) => {
    const target = event.target;
    const form = event.type === 'submit' ? target : target.closest?.('form');
    if (target.closest?.(purchaseSelector) || isPurchaseRequest(target.closest?.('a[href]')?.getAttribute('href'))
      || (event.type === 'submit' && isPurchaseRequest(form?.action || form?.getAttribute('action')))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  document.addEventListener('click', blockPurchase, true);
  document.addEventListener('submit', blockPurchase, true);

  if (typeof window.fetch === 'function') {
    const nativeFetch = window.fetch.bind(window);
    window.fetch = (input, init) => (isPurchaseRequest(input)
      ? Promise.reject(blockedError())
      : nativeFetch(input, init));
  }
  const formPrototype = window.HTMLFormElement?.prototype;
  if (formPrototype?.submit) {
    const nativeSubmit = formPrototype.submit;
    formPrototype.submit = function submit() {
      if (isPurchaseRequest(this.action || this.getAttribute?.('action'))) return;
      return nativeSubmit.call(this);
    };
  }
  const xhrPrototype = window.XMLHttpRequest?.prototype;
  if (xhrPrototype?.open && xhrPrototype?.send) {
    const nativeOpen = xhrPrototype.open;
    const nativeSend = xhrPrototype.send;
    xhrPrototype.open = function open(method, url, ...rest) {
      this.__dimPurchaseBlocked = isPurchaseRequest(url);
      return nativeOpen.call(this, method, url, ...rest);
    };
    xhrPrototype.send = function send(...args) {
      if (this.__dimPurchaseBlocked) throw blockedError();
      return nativeSend.apply(this, args);
    };
  }
  if (typeof window.navigator?.sendBeacon === 'function') {
    const nativeSendBeacon = window.navigator.sendBeacon.bind(window.navigator);
    window.navigator.sendBeacon = (url, data) => (isPurchaseRequest(url) ? false : nativeSendBeacon(url, data));
  }

  new MutationObserver(lockPurchasing).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'href'] });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lockPurchasing, { once: true });
  else lockPurchasing();
})();
